export interface CacheEntry<TKey, TValue> {
    key: TKey;
    value: TValue;
    entryTime: number;
}

export class CacheMap<TKey, TValue> {
    private readonly cacheMap = new Map<TKey, CacheEntry<TKey, TValue>>();

    constructor(private readonly maxCacheAge: number) {
    }

    get(key: TKey): TValue | undefined {
        const entry = this.cacheMap.get(key);
        if (!entry) {
            return undefined;
        }

        const isExpired = (Date.now() - entry.entryTime) > this.maxCacheAge;
        return isExpired ? undefined : entry.value;
    }

    put(key: TKey, value: TValue): void {
        this.cacheMap.set(key, { key, value, entryTime: Date.now() });
        this.deleteExpiredCache();
    }

    private deleteExpiredCache() {
        this.cacheMap.forEach(entry => {
            if ((Date.now() - entry.entryTime) > this.maxCacheAge) {
                this.cacheMap.delete(entry.key);
            }
        });
    }
}
